export default __webpack_public_path__ + "static/media/Experience Selector.892c05e8.svg";